import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export const useGetLineUps = ()=>{
    const location = useLocation();
    const jornadaid = location.pathname?.split('/')?.[3];
    const [teams, setTeams] = useState({
        selectedTeam:'local',
        local:[],
        visitor:[],
        matchInfo: {}
    })

    const handleSetLocalOrVisitor = (tag)=>{
        setTeams(prev =>({...prev, ['selectedTeam']:tag}))
        
    }

        useEffect(()=>{
        if(!jornadaid) return
        const url = 'https://web-production-58ed.up.railway.app/api/get/jornadabyid'
        axios.get(url, {params: {_id: jornadaid}}).then(res => {
            const infoJornada = res.data?.jornada
            setTeams(prev => ({...prev, local: infoJornada?.local, visitor:infoJornada?.visitante, matchInfo: infoJornada}))
        }).catch(error => console.log(error))

    },[jornadaid])

    return{ teams, handleSetLocalOrVisitor }

}